import { render, staticRenderFns } from "./MinstmarcajeGrid.vue?vue&type=template&id=294c504c"
import script from "./MinstmarcajeGrid.vue?vue&type=script&lang=js"
export * from "./MinstmarcajeGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports